var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"vz-button",class:[
    `vz-button--${_vm.type}`,
    {
      'vz-button--disabled': _vm.disabled,
      'vz-button--block': _vm.block,
      'vz-button--round': _vm.round,
    },
  ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }